<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Tabela de Estados</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Estados</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelName }}
                    </th>
                    <th scope="col" class="border-0">{{ labelInitials }}</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(state, index) in states" :key="index">
                    <td></td>
                    <td class="text-left">{{ state.Name }}</td>
                    <td>
                      {{
                        state.Initials == undefined ||
                        state.Initials == "" ||
                        state.Initials == null
                          ? "-"
                          : state.Initials
                      }}
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('State', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenState($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('State', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenState($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="$isAuthorize('State', 'Delete')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              ConfirmDeleteState(state.Name, state.Id)
                            "
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      states == undefined ||
                      states == null ||
                      states.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      size="sm"
      id="mFormState"
      :title="modalTitle"
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <!-- IdCountry -->
        <ValidationObserver tag="form" ref="validatedStateForm">
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>País</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  :disabled="isSeeing"
                  v-model="infoStates.IdCountry"
                  :class="validatedStateForm | showValidateError(invalid)"
                  :value="null"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="state in countryFilter"
                    v-bind:key="state.Id"
                    v-bind:value="state.Id"
                  >
                    {{ state.Name }}
                  </option>
                </d-select>
                <div class="invalid-feedback d-block" v-if="validatedStateForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="12" class="form-group">
              <label>{{ labelName }}</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  type="text"
                  v-model="infoStates.Name"
                  :class="validatedStateForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                />
                <div class="invalid-feedback d-block" v-if="validatedStateForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <!-- Initials -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>{{ labelInitials }}</label>
              <ValidationProvider
                rules="required|min:2"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  type="text"
                  v-model="infoStates.Initials"
                  :class="validatedStateForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                />
                <div class="invalid-feedback d-block" v-if="validatedStateForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveState()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IdCountry" :value="null">
            <option :value="null" selected>Selecione</option>
            <option
              v-for="state in countryFilter"
              v-bind:key="state.Id"
              v-bind:value="state.Id"
            >
              {{ state.Name }}
            </option>
          </d-select>
        </d-col>

        <d-col md="6" class="form-group">
          <input
            :placeholder="labelInitials"
            type="text"
            class="form-control"
            v-model="filter.Initials"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('State', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo estado"
      v-on:click="OpenState($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import dateField from "../common/date-field";
import { hasValue } from "../../utils/functions.js";
export default {
  name: "states",
  data: function () {
    return {
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      labelName: "Estado",
      labelInitials: "Sigla",
      modalTitle: "Novo Estado",
      countFilter: 0,
      filter: {
        Name: null,
        Initials: null,
        IdCountry: null,
      },
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      idState: 0,
      pOpened: null,
      states: [],
      countryFilter: [],
      infoStates: {
        Name: null,
        Initials: null,
        IdCountry: null,
      },
      isSeeing: false,
      validatedStateForm: false,
    };
  },
  components: {
    dateField,
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListState();
    },
    "pagination.RowsPerPage": function () {
      this.ListState();
    },
  },
  mounted() {
    this.ListState();
    this.ListCountryFilter();
  },
  methods: {
    OpenState: function (e, i, view) {
      e.preventDefault();
      this.validatedStateForm = false;
      this.ResetInfoState();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idState = this.states[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar Estado";
        this.GetState();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.ResetInfoState;
        this.isSeeing = false;
        this.modalTitle = "Novo Estado";
        this.ResetInfoState();
      } else {
        // View
        this.pOpened = i;
        this.idState = this.states[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do Estado";
        this.GetState();
      }
      this.$bvModal.show("mFormState");
    },
    ListCountryFilter: function () {
      this.$store
        .dispatch("ListCountry", { idCountry: 24 })
        .then((response) => {
          this.countryFilter = response;
        });
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListState();
    },
    ResetFilter: function () {
      this.filter = {
        Initials: null,
        IdCountry: null,
      };
      this.ListState();
    },
    ResetInfoState: function () {
      this.infoStates = {
        Name: null,
        Initials: null,
        IdCountry: null,
      };
    },
    SaveState: function () {
      this.validatedStateForm = true;

      this.$refs.validatedStateForm.validate().then((isValid) => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.$store
              .dispatch("AddState", this.infoStates)
              .then(() => {
                this.$makeToast(
                  "O Estado foi cadastrado com sucesso.",
                  "success",
                  "Estado cadastrado"
                );
                this.ListState();
                this.$bvModal.hide("mFormState");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao cadastrar o Estado",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.$store
              .dispatch("UpdateState", this.infoStates)
              .then(() => {
                this.$makeToast(
                  "O Estado foi atualizado com sucesso.",
                  "success",
                  "Estado atualizado"
                );
                this.ListState();
                this.$bvModal.hide("mFormState");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao atualizar o Estado",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetState: function () {
      if (this.idState != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetState", { id: this.idState })
          .then((response) => {
            this.infoStates = response;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao carregar o Estado",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListState: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.IdCountry)) this.countFilter++;
      if (hasValue(this.filter.Initials)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.IdCountry": this.filter.IdCountry,
          "Object.Initials": this.filter.Initials,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("StateList", { params: data })
        .then((response) => {
          this.states = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os Estados",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ConfirmDeleteState: function (description, id) {
      this.$makeMsgBox(
        "Você tem certeza que deseja remover " + description + " ?",
        "Confirmar",
        this.DeleteState,
        id
      );
    },
    DeleteState: function (id) {
      this.$store
        .dispatch("DeleteState", { id: id })
        .then(() => {
          this.$makeToast(
            "O País foi removido com sucesso.",
            "success",
            "Estados removido"
          );
          this.ListState();
          this.$bvModal.hide("mFormState");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover o Estados",
            error
          );
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/states.vue